import { render } from "./PublicAdvantages.vue?vue&type=template&id=40e46fd7&scoped=true"
const script = {}

import "./PublicAdvantages.vue?vue&type=style&index=0&id=40e46fd7&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e46fd7"]])

export default __exports__